/* eslint-disable react-hooks/exhaustive-deps */
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  getHospitalData,
  getHospitals,
  setPagination,
} from "../features/hospitals/hospitalSlice";
import config from "../utils/config";
import Menu from "../utils/data.dropdown";
import { capitalize } from "../utils/helper";
const { routes } = config;

export default function UseHospital() {
  const { hospitals, pagination, loading } = useSelector(getHospitalData),
    dispatch = useDispatch(),
    navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  useEffect(() => {
    let cb = () => {};

    if (pagination.search) {
      dispatch(setPagination({ page: 1 }));
      cb = setTimeout(
        (_) => (async () => await dispatch(getHospitals()))(),
        700
      );
    } else cb = (async () => await dispatch(getHospitals()))();

    return () => {
      clearTimeout(cb);
    };
  }, [pagination.search, pagination.page]);

  useEffect(() => {
    let cb = () => {};
    if (startDate && endDate) {
      dispatch(setPagination({ page: 1 }));

      cb = (async () => await dispatch(getHospitals({ startDate, endDate })))();
    }

    return () => {
      clearTimeout(cb);
    };
  }, [startDate, endDate]);

  useEffect(() => {
    setIsLoading(false);
  }, []);

  let data = hospitals?.map((hospital) => ({
    "Hospital Name": capitalize(hospital?.name),
    email: hospital?.email,
    "Phone Number": hospital?.phoneNumber,
    "Date Created ": dayjs(hospital?.createdAt).format("MMM DD, YYYY"),
    Status: hospital?.status ? "Active" : "Inactive",
    _data: hospital,
  }));

  const menu = new Menu({});
  const dropdownMenu = [
    menu.viewHospitalProfile({ navigate, routes }),
    menu.edit({
      navigate,
      route: routes.hospitals.hospital,
    }),
  ];

  return {
    data,
    isLoading,
    dropdownMenu,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    loading,
    pagination,
  };
}
